import axios from "axios";
import { BASE_URL, FRONTEND_BASE_URL } from "../utils/constants";
import toast from "react-hot-toast";
import { handleApiError } from "../utils/handleApiError";

class VideoService {

  static getToken() {
    return localStorage.getItem("authToken");
  }

  static getTenant() {
    return sessionStorage.getItem("acc_id");
  }

  static getLocationId() {
    const location = sessionStorage.getItem("current_loc");
    return location ? JSON.parse(location)?.id : null;
  }

  static getAuthHeaders(token = this.getToken()) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  static generateVideoWatchUrl(uuid) {
    if (!uuid) return null;
    return `${FRONTEND_BASE_URL}/videos/watch/${uuid}`;
  }

  static async sendVideos({ videoIds, videos, recipients, recipientType, patients = [] }) {
    const token = this.getToken();

    try {
      // Backend expects: title, url, duration, category (optional extras ignored)
      const videoData = videoIds
        .map((uuid) => {
          const video = videos.find((v) => v.uuid === uuid);
          const url = this.generateVideoWatchUrl(uuid);
          return {
            title: video?.title || "Unknown Video",
            url,
            duration: video?.duration || "",
            category: video?.category_name || video?.category || "",
          };
        })
        // drop any that don't have a valid url (backend requires url)
        .filter((v) => !!v.url);

      const recipientData = recipients.map(email => {
        const patient = patients.find(p => p.email === email);
        return {
          email: email,
          name: patient ? `${patient.first_name} ${patient.last_name}` : email
        };
      });

      const payload = {
        videos: videoData,
        recipients: recipientData,
        recipient_type: recipientType
      };

      const tenantId = this.getTenant();
      if (!tenantId) {
        throw new Error("Tenant ID not found. Please ensure you're logged in with a valid tenant.");
      }

      const url = `${BASE_URL}/patients/${tenantId}/send-videos-email/`;
      const response = await axios.post(url, payload, {
        headers: this.getAuthHeaders(token),
      });

      toast.success(`Videos sent successfully to ${recipients.length} recipient(s)`);
      return { success: true, data: response.data };

    } catch (error) {
      handleApiError(error);
      return { success: false, error: error.message };
    }
  }

  static handleApiError(error) {
    if (!error.response) {
      toast.error("Network error. Please check your internet connection.");
    } else {
      toast.error(`Failed to send videos: ${error.response?.data?.message || error.response.statusText || "Unknown error"}`);
    }
    console.error("Video Send Error:", error);
  }
}

export default VideoService;